/** Telegram WebApp 封装 */

export function getWebApp(): TelegramWebApp | null {
  return typeof window !== "undefined" ? window.Telegram?.WebApp ?? null : null;
}

export function useTelegramReady() {
  const tg = getWebApp();
  if (tg) {
    try {
      tg.ready();
      tg.expand();
      tg.setHeaderColor("#0a0e17");
      tg.setBackgroundColor("#0a0e17");
    } catch {
      /* ignore */
    }
  }
  return tg;
}

export function haptic(kind: "light" | "success" | "error" | "select" = "light") {
  const h = getWebApp()?.HapticFeedback;
  if (!h) return;
  try {
    if (kind === "success") h.notificationOccurred("success");
    else if (kind === "error") h.notificationOccurred("error");
    else if (kind === "select") h.selectionChanged();
    else h.impactOccurred("light");
  } catch {
    /* ignore */
  }
}

/** 打开外链：优先 Telegram openLink / openTelegramLink */
export function openExternal(url: string) {
  if (!url) return;
  const tg = getWebApp();
  try {
    const isTg =
      /^(https?:\/\/)?(t\.me|telegram\.me)\//i.test(url) || url.startsWith("tg://");
    if (tg) {
      if (isTg && typeof (tg as { openTelegramLink?: (u: string) => void }).openTelegramLink === "function") {
        (tg as { openTelegramLink: (u: string) => void }).openTelegramLink(url);
        return;
      }
      if (typeof tg.openLink === "function") {
        tg.openLink(url);
        return;
      }
    }
  } catch {
    /* fall through */
  }
  window.open(url, "_blank", "noopener,noreferrer");
}

/** 开发环境无 Telegram 壳时用假 initData（需后端 ESIM_TMA_DEV_BYPASS=1） */
export function resolveInitData(): string {
  try {
    const tg = getWebApp();
    if (tg?.initData) return tg.initData;
  } catch {
    /* ignore */
  }
  // 浏览器本地调试：默认开启 dev bypass（与后端 ESIM_TMA_DEV_BYPASS 对齐）
  if (
    import.meta.env.VITE_DEV_BYPASS === "1" ||
    import.meta.env.VITE_DEV_BYPASS === "true" ||
    import.meta.env.DEV
  ) {
    return JSON.stringify({
      id: 900001,
      first_name: "Dev",
      last_name: "TMA",
      username: "dev_tma",
      language_code: "zh-hans",
    });
  }
  return "";
}
